module.exports = __webpack_public_path__ + "img/s3-img4.5b54181.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/lifeHome/s3-img4.png
// module id = 415
// module chunks = 0